import type { Ordering } from "@/types/base";

export const DEFAULT_ORDERING: Ordering = { order_by: "status", descending: false };
export const PIPELINE_DEFAULT_ORDERING: Ordering = { order_by: "system:name", descending: false };

export const PAGE_SIZE = 100;
export const PIPELINE_PAGE_SIZE = 25;
export const MAX_STORED_COLUMN_WIDTHS = 200;
export const SNAPSHOT_GRID_LOAD_MORE_ROOT_MARGIN = "0px 0px 1600px 0px";
